import { IDapiRequest } from "@origin-digital/daxi";
import {
  getArticle,
  IGetArticleRequest,
  IArticleDataResponse,
} from "../../contract";
import { config } from "../../config";

const fetchArticle = async (
  data: IGetArticleRequest
): Promise<IArticleDataResponse> => {
  if (!data.slug) {
    throw new Error("Article slug is required");
  }

  const FETCH_OPTIONS: IDapiRequest = {
    method: "GET",
  };

  const response = await getArticle(
    config.apiBasePath,
    { slug: data.slug },
    FETCH_OPTIONS.authorization
  );

  return response;
};

export { fetchArticle };
